/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * DDEX copyright line
 * @export
 * @interface CreatePlaylistRequestBodyCopyrightLine
 */
export interface CreatePlaylistRequestBodyCopyrightLine {
    /**
     * Copyright year (4 characters)
     * @type {string}
     * @memberof CreatePlaylistRequestBodyCopyrightLine
     */
    year: string;
    /**
     * Copyright text
     * @type {string}
     * @memberof CreatePlaylistRequestBodyCopyrightLine
     */
    text: string;
}

/**
 * Check if a given object implements the CreatePlaylistRequestBodyCopyrightLine interface.
 */
export function instanceOfCreatePlaylistRequestBodyCopyrightLine(value: object): value is CreatePlaylistRequestBodyCopyrightLine {
    let isInstance = true;
    isInstance = isInstance && "year" in value && value["year"] !== undefined;
    isInstance = isInstance && "text" in value && value["text"] !== undefined;

    return isInstance;
}

export function CreatePlaylistRequestBodyCopyrightLineFromJSON(json: any): CreatePlaylistRequestBodyCopyrightLine {
    return CreatePlaylistRequestBodyCopyrightLineFromJSONTyped(json, false);
}

export function CreatePlaylistRequestBodyCopyrightLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlaylistRequestBodyCopyrightLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'text': json['text'],
    };
}

export function CreatePlaylistRequestBodyCopyrightLineToJSON(value?: CreatePlaylistRequestBodyCopyrightLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'text': value.text,
    };
}

